import { Box, Button, IconButton, Typography } from "@mui/material";
import { title } from "process";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface BackButtonProps {}

const BackButton: React.FC<BackButtonProps> = ({}) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <Box
      sx={{
        display: "flex",
        marginRight: 1,
      }}
    >
      <Button
        aria-label="back"
        variant="contained"
        color="primary"
        onClick={handleBackClick}
      >
        <ArrowBackIcon />
        Indietro
      </Button>
    </Box>
  );
};

export default BackButton;
